// src/services/newsApi.js
// Haber merkezi API yardımcıları.
//
// Akış üç kaynağı birleştirir: editör haberleri, tamamlanan transferler ve
// disiplin kararları. Kapsam (şehir / lig / sezon) sorgu olarak geçilir; boş
// bırakılan seviye "tümü" demektir.
import api, { apiGet, invalidateApiCache } from "../api/api";
import { uploadImage } from "./mediaUpload";

const id = (value) => encodeURIComponent(String(value));
const clean = (params) =>
  Object.fromEntries(Object.entries(params || {}).filter(([, value]) => value !== "" && value != null));

export const NEWS_CATEGORIES = {
  genel: "Genel",
  transfer: "Transfer",
  ceza: "Disiplin",
  mac: "Maç",
  duyuru: "Duyuru",
};

export const NEWS_STATUSES = { published: "Yayında", draft: "Taslak" };

export const newsApi = {
  // Public
  feed: async (params = {}, config = {}) =>
    (await apiGet("/api/news/feed", { ...config, params: clean(params) })).data,
  list: async (params = {}, config = {}) =>
    (await apiGet("/api/news", { ...config, params: clean(params) })).data,
  detail: async (publicId, config = {}) => (await apiGet(`/api/news/${id(publicId)}`, config)).data,

  // Yönetim
  adminList: async (params = {}, config = {}) =>
    (await apiGet("/api/news/admin/list", { ...config, params: clean(params) })).data,
  create: async (body) => (await api.post("/api/news", body)).data,
  update: async (publicId, body) => (await api.put(`/api/news/${id(publicId)}`, body)).data,
  remove: async (publicId) => (await api.delete(`/api/news/${id(publicId)}`)).data,
  uploadImage: async (file) => {
    const { url } = await uploadImage({
      path: "/api/news/admin/images",
      field: "image",
      file,
      method: "post",
    });
    return url;
  },

  invalidate() {
    invalidateApiCache("api/news");
  },
};

export const mapNewsError = (error) => {
  const data = error?.response?.data || {};
  const known = {
    NEWS_NOT_FOUND: "Haber bulunamadı.",
    VALIDATION_ERROR: data.message || "Lütfen form alanlarını kontrol edin.",
    UPLOAD_ERROR: data.message || "Görsel yüklenemedi.",
    ADMIN_ONLY: "Bu işlemi yalnızca yönetim yapabilir.",
  };
  return known[data.code] || data.message || "İşlem tamamlanamadı. Lütfen tekrar deneyin.";
};

export const newsDate = (value, withTime = false) => {
  if (!value) return "";
  try {
    return new Date(value).toLocaleString("tr-TR", withTime
      ? { day: "2-digit", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit" }
      : { day: "2-digit", month: "long", year: "numeric" });
  } catch {
    return String(value);
  }
};
